var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LightboxBase',{staticClass:"trailer",attrs:{"close":_vm.close}},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url,"frameborder":"0","allowfullscreen":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078ff820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lightbox/LightboxTrailer.vue
// module id = 9YM3
// module chunks = 1